import { FiUser } from "react-icons/fi";

interface StudentsEmptyStateProps {
  hasSearch: boolean;
}

function StudentsEmptyState({ hasSearch }: StudentsEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-gray-300 bg-white py-12 dark:border-gray-700 dark:bg-boxdark sm:rounded-2xl sm:py-16">
      <div className="rounded-full bg-gradient-to-br from-purple-100 to-purple-100 p-4 dark:from-purple-900/30 dark:to-purple-900/30 sm:p-6">
        <FiUser
          size={32}
          className="text-gray-400 dark:text-gray-600 sm:h-12 sm:w-12"
        />
      </div>
      <p className="mt-4 text-base font-semibold text-gray-700 dark:text-gray-300 sm:mt-5 sm:text-lg">
        {hasSearch ? "Nenhum aluno encontrado" : "Nenhum aluno cadastrado"}
      </p>
      <p className="mt-1 px-4 text-center text-xs text-gray-500 dark:text-gray-500 sm:mt-2 sm:text-sm">
        {hasSearch
          ? "Tente buscar por outro nome"
          : "Clique em 'Novo Aluno' para começar"}
      </p>
    </div>
  );
}

export default StudentsEmptyState;
